// export interface MenuItem {
//     id?: number;
//     label?: string;
//     icon?: string;
//     link?: string;
//     subItems?: any;
//     isTitle?: boolean;
//     badge?: any;
//     parentId?: number;
//     isLayout?: boolean;
//     access?:string[];
// }


export interface MenuItem {
  id: number;
  label: string;
  labelKey?: string;
  icon?: string;
  link?: string;
  queryParams?: Record<string, string | number | boolean>;
  access?: string[];
  subItems?: MenuItem[];
  parentId?: number;
  isFolder?: boolean;
  isSubItem?: boolean;
  children?: MenuItem[];
  depth?: number;
  hasChildren?: boolean;
  isOrgAsset?:boolean;
  /** Localized folder names from folder hierarchy APIs (used when language switches). */
  folderNameEn?: string;
  folderNameAr?: string;
  /** True for nodes under Department / Org Assets sidebar tree (lazy-load uses department API). */
  departmentLibraryFolder?: boolean;
  /** When true, item is shown only if `Environment.isCategoryAllowed` is true (e.g. SBU / category admin). */
  requiresCategoryAllowed?: boolean;
  /** When true, item is shown only if `Environment.showArchivedMenu` is not false (Archived sidebar link). */
  requiresArchivedMenuEnabled?: boolean;
  /** When true, item is shown only if `Environment.showMyfiles` is not false (My Files sidebar link). */
  requiresMyFilesEnabled?: boolean;
  /** When true, item is shown only if `Environment.isLocationAndTagManagementEnabled` is true. */
  requiresLocationAndTagManagementEnabled?: boolean;
}